import { RouteAuthenticationRequirement, RouteItem } from '@cksoftware/react-base';
import { AppRoles } from '../constants/appRoles';
import { Layout } from '../components/layout/layout';
import { ApplicationRoutes } from '../constants/appRoutes.ts';

export const ConsignerRoutes: RouteItem = {
  text: 'Consigning Auctions',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [AppRoles.Consigner],
  path: ApplicationRoutes.consigner.auctions,
  layout: <Layout />,
  async lazy() {
    const component = await import('../features/consigner/ConsignerAuctions');
    return { Component: component.ConsignerAuctions };
  }
};
